export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
    md: { span: 10 },
    lg: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 10 },
    md: { span: 10 },
    lg: { span: 8 }
  }
};

export const noLabelLayout = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { offset: 12, span: 10 },
    md: { offset: 10, span: 10 },
    lg: { offset: 8, span: 8 }
  }
};

export const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 14,
      offset: 8
    },
    md: {
      span: 12,
      offset: 8
    },
    lg: {
      span: 10,
      offset: 6
    }
  }
};

export const drawerFormLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
    md: { span: 10 },
    lg: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 10 },
    md: { span: 10 },
    lg: { span: 14 }
  }
};

export const drawerTailFormLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 10,
      offset: 10
    }
  }
};
